let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f8xBv")).then(() => parcelRequire('21rGX'));